import React from 'react';
import PropTypes from 'prop-types';

import SubmitButton from '../SubmitButton';

const AppleLoginButton = ({ text, handler }) => {
  return <SubmitButton text={text} handler={handler} variant="appleLogin" />;
};

AppleLoginButton.defaultProps = {
  text: 'Continue with Apple',
  handler: () => {}
};

AppleLoginButton.propTypes = {
  text: PropTypes.string,
  handler: PropTypes.func
};

export default AppleLoginButton;
